import { render } from "./SkeletonBase.vue?vue&type=template&id=4b60f828&scoped=true"
import script from "./SkeletonBase.vue?vue&type=script&lang=js"
export * from "./SkeletonBase.vue?vue&type=script&lang=js"

import "./SkeletonBase.vue?vue&type=style&index=0&id=4b60f828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b60f828"]])

export default __exports__